import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../components/LanguageContext';
import { PolicyBlocks } from '../components/legal/PolicyText';
import { trackEvent as track } from '../utils/analytics';
import { privacyPage as c, privacyPolicy, cookiePolicy, type PolicyDocument } from '../data/privacyPolicy';
import { privacyPolicyFr, cookiePolicyFr } from '../data/privacyPolicyFr';
export function PrivacyPolicy() {
  const {
    lang
  } = useLanguage();
  const fr = lang === 'FR';
  const privacy = fr ? privacyPolicyFr : privacyPolicy;
  const cookies = fr ? cookiePolicyFr : cookiePolicy;
  useEffect(() => {
    track('Page Viewed', {
      page: 'Privacy Policy'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8808" data-mp="156j36z77seku">
      <Header data-id="element-8809" data-mp="21r9vus5ree1x" />
      <main className="pt-[120px]" data-id="element-8810" data-mp="21rt3ng1p3m28">
        <div className="px-6 pt-12 pb-24 lg:pt-16 lg:pb-32" data-id="element-8811" data-mp="1wzjjkgn9hg7v">
          <div className="max-w-6xl mx-auto" data-id="element-8812" data-mp="1wxyrcxof69d6">
            <header className="max-w-3xl" data-id="element-8813" data-mp="51awsxrvih9j">
              <p className="font-sans text-xs font-semibold tracking-[0.22em] uppercase text-[#4F46E5]" data-id="element-8814" data-mp="52c9t7sg9dtw">
                {fr ? c.eyebrow.fr : c.eyebrow.en}
              </p>
              <h1 className="mt-4 font-serif text-[2.4rem] md:text-[3rem] leading-[1.08] tracking-tight text-[#121A3A]" data-id="element-8815" data-mp="3rhdoqdb4dte3">
                {privacy.title}
              </h1>
              <p className="mt-4 font-sans text-sm text-[#7A8096]" data-id="element-8816" data-mp="3ifxfw9zydzbz">{fr ? c.effectiveDate.fr : c.effectiveDate.en}</p>
            </header>

            <div className="mt-14 grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-12 lg:gap-20" data-id="element-8817" data-mp="3ng1utvl7qm03">
              <aside className="hidden lg:block" data-id="element-8818" data-mp="38it3h1vwti8d">
                <nav aria-label={fr ? c.tocLabel.fr : c.tocLabel.en} className="sticky top-[140px]" data-id="element-8819" data-mp="38k46v0lg0nyy">
                  <p className="font-sans text-[11px] font-semibold tracking-[0.18em] uppercase text-black/40" data-id="element-8820" data-mp="3dinq2t8njlnm">
                    {fr ? c.tocLabel.fr : c.tocLabel.en}
                  </p>
                  <TocGroup doc={privacy} data-id="element-8821" data-mp="1bn3o4tcc65ic" />
                  <TocGroup doc={cookies} data-id="element-8822" data-mp="1a8kg9cvk8mhd" />
                </nav>
              </aside>

              <div className="max-w-3xl min-w-0" data-id="element-8823" data-mp="158odti2ih33x">
                <PolicyDocumentView doc={privacy} hideTitle data-id="element-8824" data-mp="157wh23x6gzc2" />
                <div className="my-16 h-px bg-[#EEF0F4]" data-id="element-8825" data-mp="109cvi4mhxpk8" />
                <PolicyDocumentView doc={cookies} data-id="element-8826" data-mp="10bxumlvetrea" />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-8827" data-mp="1szblc28ilqpy" />
    </div>;
}
function TocGroup({
  doc
}: {
  doc: PolicyDocument;
}) {
  return <div className="mt-5" data-id="element-8828" data-mp="1nz760fjcf21b">
      <a href={`#${doc.id}`} className="font-sans text-[13px] font-semibold text-[#121A3A] hover:text-[#4F46E5] transition-colors duration-150" data-id="element-8829" data-mp="1o10b3qeb5e77">
        {doc.title}
      </a>
      <ul className="mt-2 space-y-1.5 border-l border-[#EEF0F4] pl-3" data-id="element-8830" data-mp="1f86unpn4k8rr">
        {doc.sections.map(s => <li key={s.id} data-id="element-8831" data-mp="2bqbhpoica2t9">
            <a href={`#${s.id}`} className="block font-sans text-[12.5px] leading-snug text-black/55 hover:text-[#4F46E5] transition-colors duration-150" data-id="element-8832" data-mp="2bqurghxu5kw7">
              {s.title}
            </a>
          </li>)}
      </ul>
    </div>;
}
function PolicyDocumentView({
  doc,
  hideTitle = false
}: {
  doc: PolicyDocument;
  hideTitle?: boolean;
}) {
  return <article id={doc.id} className="scroll-mt-[140px]" aria-label={doc.title} data-id="element-8833" data-mp="2g3nlpvimkr3">
      {!hideTitle && <h2 className="font-serif text-[2rem] md:text-[2.4rem] leading-[1.1] tracking-tight text-[#121A3A]" data-id="element-8834" data-mp="7fyg1xuxvie9">{doc.title}</h2>}
      {doc.intro && <PolicyBlocks blocks={doc.intro} data-id="element-8835" data-mp="ccowimanog07" />}
      {doc.sections.map(s => <section key={s.id} id={s.id} className="mt-12 first:mt-0 scroll-mt-[140px]" aria-labelledby={`${s.id}-title`} data-id="element-8836" data-mp="hcky6evvrvcl">
          {hideTitle ? <h2 id={`${s.id}-title`} className="font-serif text-[1.45rem] md:text-[1.6rem] leading-tight text-[#121A3A]" data-id="element-8837" data-mp="q66cjx44valh">{s.title}</h2> : <h3 id={`${s.id}-title`} className="font-serif text-[1.35rem] md:text-[1.5rem] leading-tight text-[#121A3A]" data-id="element-8838" data-mp="v6u4qm43lxha">{s.title}</h3>}
          <PolicyBlocks blocks={s.blocks} data-id="element-8839" data-mp="mhn56uevkd0u" />
        </section>)}
    </article>;
}